// Room creation and student join form for the workspace sidebar.
import type { Role } from '../../types';

type RoomSetupPanelProps = {
  role: Role;
  name: string;
  password: string;
  roomInput: string;
  onNameChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onRoomInputChange: (value: string) => void;
  onCreateRoom: () => void;
  onJoinRoom: () => void;
};

export function RoomSetupPanel({
  role,
  name,
  password,
  roomInput,
  onNameChange,
  onPasswordChange,
  onRoomInputChange,
  onCreateRoom,
  onJoinRoom
}: RoomSetupPanelProps) {
  return (
    <section className="panel">
      <h2>{role === 'trainer' ? 'Создать комнату' : 'Войти в комнату'}</h2>
      <label htmlFor="participant-name">Имя</label>
      <input id="participant-name" value={name} onChange={(event) => onNameChange(event.target.value)} />
      {role === 'trainer' ? (
        <>
          <label htmlFor="trainer-password">Пароль</label>
          <input
            id="trainer-password"
            type="password"
            value={password}
            onChange={(event) => onPasswordChange(event.target.value)}
          />
          <button className="primary full" onClick={onCreateRoom}>Создать комнату</button>
        </>
      ) : (
        <>
          <label htmlFor="room-code">Код комнаты</label>
          <input
            id="room-code"
            value={roomInput}
            onChange={(event) => onRoomInputChange(event.target.value.toUpperCase())}
            placeholder="ABC123"
          />
          <button className="success full" onClick={onJoinRoom}>Подключиться</button>
        </>
      )}
    </section>
  );
}
